// @flow

import gql from 'graphql-tag';

export const teamMemberFragment = gql`
  fragment teamMember on TeamMember {
    avatarUrl
    email
    id
    name
    userId
  }
`;
